// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';

export const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        fill="black"
        d="M9.4364 8.81967L13.8886 13.2719C13.9631 13.3551 14.0029 13.4637 13.9998 13.5753C13.9968 13.6869 13.951 13.7931 13.8721 13.8721C13.7931 13.951 13.6869 13.9968 13.5753 13.9998C13.4637 14.0029 13.3551 13.9631 13.2719 13.8886L8.81967 9.4364C8.74518 9.3532 8.70538 9.24464 8.70846 9.13301C8.71154 9.02139 8.75725 8.91518 8.83622 8.83622C8.91518 8.75725 9.02139 8.71154 9.13301 8.70846C9.24464 8.70538 9.3532 8.74518 9.4364 8.81967ZM5.32625 0C6.73886 0 8.09361 0.561157 9.09248 1.56002C10.0913 2.55889 10.6525 3.91364 10.6525 5.32625C10.6525 6.73886 10.0913 8.09361 9.09248 9.09248C8.09361 10.0913 6.73886 10.6525 5.32625 10.6525C3.91364 10.6525 2.55889 10.0913 1.56002 9.09248C0.561157 8.09361 0 6.73886 0 5.32625C0 3.91364 0.561157 2.55889 1.56002 1.56002C2.55889 0.561157 3.91364 0 5.32625 0ZM5.32625 0.863413C2.86552 0.863413 0.863413 2.86552 0.863413 5.32625C0.863413 7.78698 2.86552 9.78909 5.32625 9.78909C7.78698 9.78909 9.78909 7.78698 9.78909 5.32625C9.78909 2.86552 7.78698 0.863413 5.32625 0.863413Z"
      />
    </svg>
  );
};

export const SearchIconNewDesign = ({ width = 28, height = 28 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
    >
      <g clipPath="url(#clip0_331_1246)">
        <path
          d="M13.2222 19.4444C16.6587 19.4444 19.4444 16.6587 19.4444 13.2222C19.4444 9.78578 16.6587 7 13.2222 7C9.78578 7 7 9.78578 7 13.2222C7 16.6587 9.78578 19.4444 13.2222 19.4444Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.0002 21L17.6168 17.6167"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_331_1246">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M16 4L4 16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 4L16 16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <rect opacity="0.01" width="30" height="30" fill="#F3F3F3" />
      <path
        d="M19.2224 8.12691L12.6828 14.6666L19.2224 21.2062C19.4422 21.426 19.4422 21.7822 19.2224 22.002C19.1125 22.1119 18.9689 22.1666 18.8249 22.1666C18.6809 22.1666 18.5369 22.1119 18.427 22.002L11.8874 15.462C11.4876 14.8982 11.7205 14.462 11.8871 14.1666C12.0537 13.8713 18.427 7.33116 18.427 7.33116C18.6468 7.11178 19.003 7.11178 19.2224 7.33116C19.4422 7.55091 19.4422 7.90716 19.2224 8.12691Z"
        fill="black"
      />
    </svg>
  );
};

export const SearchIconNew = () => {
  return (
    <span className="svg-icon-wrapper-new search-icon-mob">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        id="svg-search-icon"
      >
        <g clipPath="url(#clip0_331_2261)">
          <path
            d="M17 24C21.4183 24 25 20.4183 25 16C25 11.5817 21.4183 8 17 8C12.5817 8 9 11.5817 9 16C9 20.4183 12.5817 24 17 24Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.0001 26L22.6501 21.65"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_331_2261">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};
